import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from "@angular/router";
import { inject, Injectable } from "@angular/core";
import { LiveSessionStateService } from "live-lesson/shared/data-access-call-state";
import { filter, map } from "rxjs";
import { isNotNullOrUndefined } from "@pcp/core/util";

@Injectable()
export class LessonHasNotEndedGuard implements CanActivate {

    private readonly router = inject(Router);

    private readonly liveLessonStateService = inject(LiveSessionStateService);
    readonly liveLessonState$ = this.liveLessonStateService.state$;

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        return this.liveLessonStateService.state$.pipe(
            filter(isNotNullOrUndefined),
            map(state => {
                if (state === 'ended') {
                    return this.router.createUrlTree(['call-ended']);
                }

                if (state === 'expired') {
                    return this.router.createUrlTree(['expired']);
                }

                return true;
            }),
        );
    }
}
